import { useLocation } from "react-router-dom";
import { Seo } from "./Seo";
import { getRouteMeta, canonicalUrl } from "../seo/routeMeta";

export const RouteSeo = () => {
  const { pathname } = useLocation();
  const meta = getRouteMeta(pathname);
  if (!meta) return null;
  return (
    <Seo
      title={meta.title}
      description={meta.description}
      canonical={canonicalUrl(meta.canonical)}
    />
  );
};
